import React, { SVGAttributes } from 'react';
import { motion } from 'framer-motion';

type Props = Pick<
  SVGAttributes<SVGCircleElement>,
  | 'stroke'
  | 'strokeLinecap'
  | 'strokeWidth'
  | 'fill'
  | 'r'
  | 'cx'
  | 'cy'
  | 'strokeDasharray'
> & {
  initialStrokeDashoffset: number;
  finalStrokeDashOffset: number;
};

const ANIMATION_DURATION = 0.6;
const ANIMATION_DELAY = 0.3;

const AnimatedCircle = ({
  initialStrokeDashoffset,
  finalStrokeDashOffset,
  ...rest
}: Props) => (
  <motion.circle
    transition={{
      duration: ANIMATION_DURATION,
      delay: ANIMATION_DELAY,
      ease: 'easeInOut',
    }}
    initial={{
      strokeDashoffset: initialStrokeDashoffset,
    }}
    animate={{
      strokeDashoffset: finalStrokeDashOffset,
    }}
    {...rest}
  />
);

export default AnimatedCircle;
